import { Component, Host, Prop, State, h } from '@stencil/core';
import mapboxgl from 'mapbox-gl';

@Component({
  tag: 'lg-map',
})
export class LgMap {
  @Prop() lat: string;
  @Prop() lng: string;
  @Prop() zoom = '16';
  @Prop() styleUrl: string;

  @State() map: mapboxgl.Map;
  private mapEl?: HTMLElement;

  componentDidLoad() {
    mapboxgl.accessToken = 'pk.eyJ1IjoiYXdpZG1lciIsImEiOiJjam40aHo3aTAwZTFuM3dvY21laXcyenczIn0.oezoz84fKKN8Qz3xNVXAIQ';
    this.map = new mapboxgl.Map({
      container: this.mapEl,
      center: [this.lng, this.lat], // starting position [lng, lat]
      zoom: parseInt(this.zoom), // starting zoom
      style: this.styleUrl || 'mapbox://styles/awidmer/clycw7uz000m801pga9gz6qcz',
    });

    // Add zoom and rotation controls to the map.
    this.map.addControl(new mapboxgl.NavigationControl());

    // disable map zoom when using scroll
    this.map.on("wheel", event => {
      if (event.originalEvent.ctrlKey) {
          return;
      }
      if (event.originalEvent.metaKey) {
          return;
      }
      if (event.originalEvent.altKey) {
          return;
      }
      event.preventDefault();
    });

    // create DOM element for the marker
    const el = document.createElement('lg-icon');
    el.name = 'marker';
    el.className = 'Map__marker';

    new mapboxgl.Marker(el)
      .setLngLat([this.lng, this.lat])
      .addTo(this.map);
  }

  render() {
    return (
      <Host>
        <div ref={el => (this.mapEl = el)} class="Map__container"></div>
      </Host>
    );
  }
}
